











import Vue from 'vue';
import enteSanitarioEdit from '@/components/commands/EnteSanitarioEdit.vue';

export default Vue.extend({
    components: { enteSanitarioEdit },
    methods: {
        close() {
            this.$router.push({
                name: 'EnteSanitarioList',
            });
        },
    },
});
